import api from './api'

const dashboardService = {
  // Get dashboard statistics
  getDashboardStats: () => api.get('/mrd/dashboard/stats'),

  // Get master data statistics
  getMasterDataStats: () => api.get('/mrd/dashboard/master-stats'),

  // Get dashboard overview
  getDashboardOverview: () => api.get('/mrd/dashboard/overview'),

  // Get recent activities
  getRecentActivities: (params) => api.get('/mrd/dashboard/activities', { params }),

  // Get performance metrics
  getPerformanceMetrics: (params) => api.get('/mrd/dashboard/performance', { params }),

  // Get alerts and notifications
  getAlerts: () => api.get('/mrd/dashboard/alerts'),

  // Get workflow status
  getWorkflowStatus: () => api.get('/mrd/dashboard/workflow-status'),

  // Get department wise statistics
  getDepartmentStats: () => api.get('/mrd/dashboard/department-stats'),

  // Get monthly trends
  getMonthlyTrends: (params) => api.get('/mrd/dashboard/trends', { params }),

  // Get top performers
  getTopPerformers: (params) => api.get('/mrd/dashboard/top-performers', { params }),

  // Get pending tasks
  getPendingTasks: () => api.get('/mrd/dashboard/pending-tasks'),

  // Mark alert as read
  markAlertAsRead: (alertId) => api.put(`/mrd/dashboard/alerts/${alertId}/read`),

  // Get user dashboard preferences
  getDashboardPreferences: () => api.get('/mrd/dashboard/preferences'),

  // Update dashboard preferences
  updateDashboardPreferences: (preferences) => 
    api.put('/mrd/dashboard/preferences', preferences)
}

export default dashboardService